import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import CharacterSkeleton from './CharacterSkeleton';
import SituationSkeleton from './SituationSkeleton';

const loadingCSS = css`
  .character {
    padding: 0 ${Spacing.medium}px;
  }

  .situation {
    display: flex;
    width: 100%;
    overflow: hidden;
    padding: 0 ${Spacing.medium}px;
    gap: ${Spacing.small}px;
    margin-top: ${Spacing.small}px;
  }
`;
const PlaySkeleton = () => {
  return (
    <div css={loadingCSS}>
      <div className="character">
        <CharacterSkeleton />
      </div>
      <div className="situation">
        <SituationSkeleton />
        <SituationSkeleton />
        <SituationSkeleton />
        <SituationSkeleton />
      </div>
    </div>
  );
};

export default PlaySkeleton;
